//선박 검사 일정
import React from "react";
import { Button, Container } from "@mui/material";
import ManagerAppBar from "../common/ManagerAppBar";
import { CDateTest } from "../../../components/CDateTest";
import { useState } from "react";
import { addMonths, format, subMonths } from "date-fns";

import { Link } from "react-router-dom";

import { mainColor } from "../../../assets/colors/color";
import ListBoxTest from "../../../components/ListBoxTest";
import { getInspectionList } from "../../../recoil/GetData";
import { useRecoilValue } from "recoil";
import ShipInspection from "../../../components/ShipInspection";
import { loginAuthenticationAdmin } from "../../../hooks/loginAuthentication";
function ManagerInspectionSchedule() {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const selectDay = format(selectedDate, "yyyy-MM-dd");
  const year = format(currentMonth, "yyyy");
  const month = format(currentMonth, "MM");

  React.useEffect(() => {
    loginAuthenticationAdmin();
  }, []);

  const shipScheduleData = useRecoilValue(
    getInspectionList(`list?year=${year}&month=${month}`)
  );
  console.log(shipScheduleData);

  const prevMonth = () => {
    setCurrentMonth(subMonths(currentMonth, 1));
  };
  const nextMonth = () => {
    setCurrentMonth(addMonths(currentMonth, 1));
  };

  const onDateClick = (day) => {
    setSelectedDate(day);
  };
  return (
    <div>
      <ManagerAppBar />
      <Container
        maxWidth="sm"
        sx={{
          position: "relative",
          marginTop: "76px",
          marginBottom: "60px",
          gap: "10px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <h1 style={{ fontSize: "20px" }}>선박 검사 일정</h1>
        <CDateTest
          edata={shipScheduleData && shipScheduleData}
          onDateClick={onDateClick}
          selectedDate={selectedDate}
          prevMonth={prevMonth}
          nextMonth={nextMonth}
          currentMonth={currentMonth}
        />
        <p
          style={{
            fontSize: 20,
            fontWeight: 700,
            color: `${mainColor}`,
            padding: "8px 0",
          }}
        >
          선택된 날짜 : {selectDay}{" "}
        </p>
        <ListBoxTest
          edata={shipScheduleData && shipScheduleData}
          selectedDate={selectedDate}
          NextPageType={"ManagerInspectionSchedule"}
        />
        <ShipInspection />
        <Link
          to="/manager-registation-inspection-schedule"
          style={{
            textDecoration: "none",
            color: "inherit",
          }}
        >
          <Button
            sx={{
              maxWidth: "1200px",
              width: "100%",
              bottom: 0,
              borderRadius: 0,
              height: 50,
              left: "50%",
              transform: "translateX( -50% )",
              position: "fixed",
              borderTop: "2px solid #fff",
            }}
            variant="contained"
            color="secondary"
          >
            등록하기
          </Button>
        </Link>
      </Container>
    </div>
  );
}

export default ManagerInspectionSchedule;
